import React from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Modal
} from "reactstrap";
import Avatar from "../static/img/fav.png";
import Contact from "./Contact";
import Linkedin from "../static/img/linkedin.jpg";
import { Fade } from "react-reveal";

// import Contact from "./Contact";

export default class Navigation extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      modal: false,
      contactModal: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  toggleModal = () => {
    this.setState({
      modal: !this.state.modal
    });
  };
  handleMenu = name => {
    this.props.scrollTo(name);
  };

  render() {
    return (
      <Fade right duration={1000} distance="20px">

      <div className="container navigation-bar remove-padding">
        <Navbar color="faded" light expand="md">
          <NavbarBrand href="/">
            <div className="avatar-container">
              <img
                alt="logo"
                className="circle-avatar"
                height={50}
                src={Avatar}
              />
              <div >
                 <span >Takwa .C </span>
      <span> </span>
                <span> Software engineer - TN </span>
              </div>
            </div>
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>

            <NavItem>
                <NavLink
                  className="menu-item"
                  href="#"
                  onClick={() => this.handleMenu("about")}
                >
                  about me
                </NavLink>
              </NavItem>
              
              
            <NavItem>
                <NavLink
                  className="menu-item"
                  href="#"
                  onClick={() => this.handleMenu("skills")}
                >
                  Skills

                </NavLink>
              </NavItem>

              <NavItem>
                <NavLink
                  className="menu-item"
                  onClick={() => this.handleMenu("work")}
                >
Certificates & projects
                </NavLink>
              </NavItem>

           
              <NavItem>
                <NavLink
                  onClick={() => this.handleMenu("blog")}
                  className="menu-item"
                  href="#"
                >
                 Slides
                </NavLink>
              </NavItem>

              
              <NavItem>
                <NavLink
                  className="menu-item rounded-link"
                  href="#"
                  onClick={this.toggleModal}
                >
Contact me </NavLink>     </NavItem>
               
              <NavItem>
                <NavLink>
                  <div className="social">
                  <a  href="https://www.linkedin.com/in/takwachaabane"
                      target="_blank" >
                       <img
                        alt="linkedin"
                        src={Linkedin}
                      />
                    </a>
                  </div>
                </NavLink>
              </NavItem>

            </Nav>
          </Collapse>
        </Navbar>
        <Modal isOpen={this.state.modal} toggle={this.toggleModal} className="w-100">
          <Contact/>
        </Modal>
      </div>
      </Fade>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Navigation.js